var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({class:[
		_vm.$s.ActionBarLayer,
		( _obj = {}, _obj[_vm.$s.NoActionBar] = !_vm.hasActionBar, _obj ) ]},'div',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('m-transition-spring-up',[(_vm.actionBarVnodes)?_c('atomic-action-bar',{attrs:{"hide-on":"tablet","position":"fixed"}},[_c('v',{attrs:{"nodes":_vm.actionBarVnodes}})],1):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }